import React from 'react';
import { PageSkeleton as SchedulesPageSkeleton } from '@jira/servicedesk__schedules/src/PageSkeleton.tsx';

export const PageSkeleton = (): React.JSX.Element => <SchedulesPageSkeleton />;
